import { Field } from '../entities/field.model';
import { DropDownItem } from '../../fields/dropdown-item.model';


export class DataCell {
    constructor(
        public field?: Field,
        public dropDownItems?: DropDownItem[]) { }
}
